module.exports = __webpack_public_path__ + "img/icon_phone_white.c254b4ab.svg";